import React from 'react';
import Icon from '../../../components/AppIcon';

const RegionalPerformanceGrid = ({ regions }) => {
  const getPerformanceColor = (performance) => {
    if (performance >= 95) return 'text-success';
    if (performance >= 85) return 'text-warning';
    return 'text-error';
  };

  const getPerformanceIcon = (performance) => {
    if (performance >= 95) return 'TrendingUp';
    if (performance >= 85) return 'Minus';
    return 'TrendingDown';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">Regional Performance</h3>
          <p className="caption text-muted-foreground">Transaction success rates by region</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-muted/30 hover:bg-muted/50 transition-smooth">
          <Icon name="Download" size={16} className="text-foreground" />
          <span className="text-sm font-medium text-foreground">Export</span>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {regions?.map((region) => {
          const performanceColor = getPerformanceColor(region?.performance);
          const performanceIcon = getPerformanceIcon(region?.performance);
          const isAboveThreshold = region?.performance >= 90;

          return (
            <div
              key={region?.id}
              className={`p-4 rounded-lg border transition-smooth hover:shadow-md ${
                isAboveThreshold
                  ? 'border-success/30 bg-success/5' :'border-border bg-card'
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-2">
                  <Icon name="MapPin" size={20} className="text-primary" />
                  <h4 className="text-base font-semibold text-foreground">{region?.name}</h4>
                </div>
                {isAboveThreshold && (
                  <Icon name="CheckCircle" size={16} className="text-success" />
                )}
              </div>
              <div className="space-y-3">
                <div>
                  <div className="flex items-center justify-between mb-1">
                    <span className="caption text-muted-foreground">Success Rate</span>
                    <div className="flex items-center gap-1">
                      <Icon name={performanceIcon} size={14} className={performanceColor} />
                      <span className={`text-sm font-bold ${performanceColor}`}>
                        {region?.performance}%
                      </span>
                    </div>
                  </div>
                  <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                    <div
                      className={`h-full transition-all duration-500 ${
                        isAboveThreshold ? 'bg-success' : 'bg-warning'
                      }`}
                      style={{ width: `${region?.performance}%` }}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <p className="caption text-muted-foreground mb-1">Volume</p>
                    <p className="text-sm font-semibold text-foreground">{region?.volume}</p>
                  </div>
                  <div>
                    <p className="caption text-muted-foreground mb-1">Revenue</p>
                    <p className="text-sm font-semibold text-foreground">{region?.revenue}</p>
                  </div>
                </div>

                <div>
                  <p className="caption text-muted-foreground mb-1">Active Users</p>
                  <div className="flex items-center gap-2">
                    <Icon name="Users" size={14} className="text-muted-foreground" />
                    <p className="text-sm font-semibold text-foreground">{region?.activeUsers}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegionalPerformanceGrid;